/**
 * El copy de «Probá tu bot» (GKTIBO-75).
 *
 * Vive aparte por el mismo motivo que el de la entrevista: `textos.ts` pasó de
 * 300 líneas y la regla D4 no se negocia moviendo la línea base. Partirlo por
 * área es lo que ya hacía el proyecto.
 *
 * ⚠️ No se dice «banco de pruebas»: es jerga y describe mal la cosa. No es una
 * herramienta de QA apartada — es el paso donde el dueño ve a su bot antes de
 * que lo vea un cliente.
 */

export const probar = {
  // La franja del paso 2 cuando la caja ya es su bot (GKTIBO-124).
  hablasConTuBot: 'Ahora hablás con tu bot',
  hablasConTuBotConNombre: (nombre: string) => `Ahora hablás con ${nombre}, tu bot`,
  comoUnClienteDe: (negocio: string) => `Escribile como lo haría un cliente de ${negocio}`,
  noTocaTuNegocio: 'No escribe en tu negocio',
  titulo: 'Probá tu bot',
  // Dice para qué sirve, no qué es. «Chat de prueba» no le dice a nadie por
  // qué debería usarlo.
  bajada:
    'Escribile como lo haría un cliente. Debajo de cada respuesta vas a ver de dónde la sacó.',
  // Dice a qué negocio le habla. Con uno solo no es ruido: es tranquilizador.
  deQuien: 'Estás probando el bot de',

  escribi: 'Escribile a tu bot…',
  // Sugiere qué escribir EL DUEÑO. Sembrar una respuesta de ejemplo sería
  // justo lo que esta pantalla viene a detectar (G3, L27).
  vacio:
    'Todavía no escribiste nada. Probá con algo que te preguntaría un cliente, como «¿a qué hora abren?».',
  enviar: 'Enviar',
  pensando: 'Pensando…',

  // La atribución. El verbo en condicional en lo simulado no es estilo: es
  // la diferencia entre avisar y mentir.
  salioDe: 'Salió de tu sección',
  consulto: (cuantas: number) =>
    cuantas === 1 ? 'Consultó 1 herramienta' : `Consultó ${cuantas} herramientas`,
  // El caso que esta pantalla viene a cazar.
  sinFuente: 'Respondió sin consultar nada. Revisá si lo que dijo es cierto.',
  simulado: 'En una prueba no pasa de verdad: en vivo esto',

  // Corregir lo que salió mal (GKTIBO-77).
  // Valorar y enseñar (GKTIBO-115).
  respondioBien: 'Respondió bien',
  respondioMal: 'Respondió mal',
  graciasPorValorar: 'Anotado. Eso queda como algo que tu bot ya hace bien.',

  // Pide una LECCIÓN, no un dictado. «Qué debería haber contestado» empuja a
  // escribir respuestas, y algunas no son conocimiento del negocio: en un
  // tenant quedó guardado «Ok perfecto, muchas gracias» como si fuera una FAQ.
  leccionTitulo: '¿Qué estuvo mal?',
  leccionAyuda:
    'Contámelo con tus palabras, como se lo explicarías a alguien que recién entra a trabajar.',
  leccionEjemplo: 'Ej: no prometas domicilio en toda la ciudad, sólo vamos al norte.',
  leccionVerQueGuardar: 'Ver qué guardar',
  leccionVolverAEscribir: 'Volver a escribir',

  // El dueño lee el texto exacto ANTES de que se guarde. Esa persona entre el
  // modelo y el archivo es lo único que impide que una invención llegue al
  // bot en silencio (GKTIBO-88).
  leccionEstoSeGuarda: 'Esto es lo que va a quedar en el conocimiento de tu bot:',
  leccionSinAsistente:
    'No pudimos ordenarlo con el asistente, así que se va a guardar tal cual lo escribiste.',
  leccionNoSePudo: 'No pudimos guardar esto ahora. Tu texto sigue acá: probá de nuevo.',

  // A dónde va la corrección, en su idioma (GKTIBO-146). El dueño lo lee
  // ANTES de guardar y puede cambiarlo: una regla que cayera como dato del
  // negocio se cumpliría sólo cuando la búsqueda la trajera.
  destinoTitulo: '¿Qué es esto?',
  tipoConocimiento: 'Algo que tu negocio hace o no hace',
  tipoComportamiento: 'Cómo tiene que responder tu bot',
  tipoDefecto: 'El bot dijo que hizo algo que no hizo, o inventó',
  destinoConocimiento: (seccion: string) => `Lo guardo en «${seccion}».`,
  destinoComportamiento: 'Lo guardo como una regla de cómo responder.',
  destinoDefecto:
    'Esto es un error nuestro. Lo anotamos para revisarlo; no cambia lo que tu bot sabe.',
  seccionDe: {
    sobre: 'Sobre tu negocio',
    ofrece: 'Qué ofrecés',
    horarios: 'Cuándo atendés',
    noHace: 'Qué NO hacés',
    escalar: 'Cuándo pasar a una persona',
    extra: 'Lo que quieras agregar',
    otros: 'Otros',
    // Las secciones que Tibo propone y el dueño acepta (GKTIBO-147). Copia
    // de la lista cerrada del servidor: el panel no puede importar el paquete.
    precios: 'Precios',
    sedes: 'Sedes',
    pagos: 'Formas de pago',
    garantia: 'Garantía',
    envios: 'Envíos',
    requisitos: 'Requisitos',
    equipo: 'Equipo',
  } as Record<string, string>,
  anotarDefecto: 'Anotarlo',
  defectoAnotado: 'Anotado. Lo revisamos nosotros. Lo que tu bot sabe no cambió.',

  corregir: 'Corregir',
  corregirTitulo: 'Enseñale qué debería haber contestado',
  corregirAyuda: 'Escribilo con tus palabras. Se guarda tal cual, sin que nadie lo reescriba.',
  corregirGuardar: 'Guardar la corrección',
  corregirCancelar: 'Cancelar',
  // Dice que todavía NO está en vivo. Prometer que ya quedó, mientras el bot
  // sigue contestando lo viejo, es el mismo pecado que esta pantalla caza.
  corregirGuardada: 'Guardado. Tu bot lo va a usar en unos minutos, cuando termine de aprenderlo.',
  corregirNoSePudo: 'No pudimos guardar la corrección. Tu texto sigue acá: probá de nuevo.',

  quedan: (n: number) => `Te quedan ${n} mensajes de prueba.`,
  sesionNueva: 'Tu bot no recuerda lo anterior: esta prueba empezó de nuevo.',

  // Dice que falló LA PRUEBA, no que el bot no entendió. Culpar a la
  // respuesta del dueño por un error nuestro es peor que el error.
  noSePudo: 'No pudimos probar tu bot ahora. Tu mensaje sigue acá: probá de nuevo.',
  sinTenant: 'Elegí un negocio para probar su bot.',
} as const;
